/**
 * Surfaces allowed to open the upload widget, keyed by `useCase.subArea`. Default-deny: a new subArea stays on
 * Filestack until it is listed here. One subArea covers several surfaces, so verify each one uploads end to end
 * before adding it; an unverified one 400s against the upload service.
 */
const WIDGET_ENABLED_SUB_AREAS: ReadonlySet<string> = new Set(['websitePhotos', 'mediaCollection', 'websiteDesigner', 'message', 'contactCollector', 'stationery', 'registry']);

/** Whether a surface may open the upload widget instead of Filestack. No `useCase`, or an unlisted one, keeps Filestack. */
export const resolveIsWidgetEnabled = ({ flagEnabled, subArea }: { flagEnabled: boolean; subArea?: string }): boolean =>
  flagEnabled && !!subArea && WIDGET_ENABLED_SUB_AREAS.has(subArea);

/**
 * Whether this surface is one video could ever be **uploaded** on, ignoring the rollout flag. The host must
 * opt in (`canShowVideo` on `PhotoPickerDialog`), and the widget gate must already be resolved: the legacy
 * Filestack pipeline cannot carry a video, so the chooser would accept one and it would fail downstream.
 * Kept apart from the rollout flag, which `useIsVideoUploadEnabled` ANDs in.
 */
export const resolveIsVideoSurface = ({ widgetEnabled, canShowVideo = false }: { widgetEnabled: boolean; canShowVideo?: boolean }): boolean => widgetEnabled && canShowVideo;
